<template>
  <div class="container py-5">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <div class="card">
          <div class="card-body text-center">
            <div v-if="loading" class="py-4">
              <span class="spinner-border" role="status" aria-hidden="true"></span>
              <p class="mt-3 mb-0">Completing SSO configuration...</p>
            </div>

            <div v-else-if="error" class="py-4">
              <fa icon="exclamation-triangle" class="text-danger mb-3" size="3x" />
              <h5>Configuration Error</h5>
              <p class="text-muted">{{ errorMessage }}</p>
              <button class="btn btn-primary" @click="goToOrganization">Return to Organization Settings</button>
            </div>

            <div v-else class="py-4">
              <fa icon="check-circle" class="text-success mb-3" size="3x" />
              <h5>SSO Configuration Complete</h5>
              <p class="text-muted">Your SSO settings have been saved successfully.</p>
              <button class="btn btn-primary" @click="goToOrganization">Return to Organization Settings</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      error: null,
    };
  },
  computed: {
    organizationId() {
      return this.$route.query.organizationId;
    },
    errorMessage() {
      if (!this.error) return "";
      if (this.error.response?.data?.title) return this.error.response.data.title;
      if (this.error.message) return this.error.message;
      return "An unexpected error occurred.";
    },
  },
  created() {
    this.refreshSsoStatus();
  },
  methods: {
    refreshSsoStatus() {
      if (!this.organizationId) {
        this.error = { message: "Organization ID not provided." };
        this.loading = false;
        return;
      }

      this.$axios
        .get(`/v1/organizations/${this.organizationId}/sso-config`)
        .then(() => {
          this.loading = false;
        })
        .catch(err => {
          this.error = err;
          this.loading = false;
        });
    },
    goToOrganization() {
      if (this.organizationId) {
        this.$router.push(`/organizations/${this.organizationId}/ssoconfig`);
      } else {
        this.$router.push("/organizations");
      }
    },
  },
};
</script>
